import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ServiceBase } from '../service.base';
import { AuthService, ResponseObject } from '../auth.service';

export interface EventTypeViewModel {
  id: string;
  name: string;
  description: string;
  isPredefined: boolean;
  isEmailEvent: boolean;
  createdDate: string;
  emailParameterIds: string[];
}

export interface SmsTemplatePayload {
  id: string;
  systemEventId: string;
  text: string;
  createdDate: string;
  modifiedDate: string;
  eventTypeViewModel: EventTypeViewModel;
}

export interface SendSMSTestData {
  SendTo: string;
  Text: string;
}

@Injectable({
  providedIn: 'root'
})
export class SmsTemplateService extends ServiceBase {
  private api: string = '/SmsTemplate';

  constructor(private http: HttpClient, authService: AuthService) {
    super(authService);
  }

  public getAllSmsTemplates(): Observable<SmsTemplatePayload[]> {
    const httpOptions = this.RequestHeaders();
    const method: string = '/fetch';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<SmsTemplatePayload[]>(url, httpOptions);
  }

  public getSmsTemplate(id: string): Observable<SmsTemplatePayload> {
    const httpOptions = this.RequestHeaders();
    const method: string = `/fetch/${id}`;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<SmsTemplatePayload>(url, httpOptions);
  }

  public saveSmsTemplate(data: SmsTemplatePayload): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const url = `${environment.BASE_API_PATH}${this.api}/save-update`;
    return this.http.post<ResponseObject>(url, data, httpOptions);
  }

  public deleteSmsTemplate(id: string): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const method: string = `/delete/${id}`;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.delete<ResponseObject>(url, httpOptions);
  }

  public sendTestSMS(data: SendSMSTestData): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const url = `${environment.BASE_API_PATH}${this.api}/send-test`;
    return this.http.post<ResponseObject>(url, data, httpOptions);
  }
}